<template>
  <div>
    <div class="section-header pageHeader" ref="headerWrapper">
      <h1>{{title}} <template v-if="refno"> - {{refno}}</template></h1>
      <div class="section-header-breadcrumb">
        <div
          v-if="isActionValid(a.condition)&&!isEdit"
          v-for="a in wfDtl.wfActions"
          :key="a.id"
          class="mt-3 mt-lg-0 mr-lg-3"
        >
          <button
            type="button"
            class="btn legitRipple"
            :class="a.bg_class || 'btn-primary'"
            @click="a.name=='Reject'?wfNoteClicked():wfActionClicked(a, a.required_note)"
          >
            <i class="mr-2" :class="((a.name == 'Submit')||(a.name == '提交')||(a.name == '批核')||(a.name == 'Approve')?'fas fa-check-square':((a.name == 'Reject')||(a.name == '拒絕')?'fas fa-times-circle':((a.name == 'Confirm')||(a.name == '確認')?'fas fa-check-square':'')))"></i>
            {{$helper.getWord(a.name)}}
          </button>
        </div>
        <div v-if="wfDtl.wfActions && wfDtl.wfActions.length > 0 && beReject" class="mt-3 mt-lg-0 mr-lg-3">
          <button type="button" class="btn legitRipple btn-primary" @click="wfNoteClicked">
            <i class="mr-2 far fa-comment-alt"></i> {{$helper.getWord('note')}}
          </button>
        </div>
        <slot name="buttons"></slot>
      </div>
    </div>



    <!-- Workflow note modal -->
    <div id="wfNoteDialog" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" style="color:#fff">{{$helper.getWord('Workflow Note')}}</h5>
            <button type="button" class="close" @click="cancelNoteClick" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <textarea ref="note"  rows="5" class="form-control" v-model="note" v-if="!beReject"  style="height:200px"></textarea>
            <textarea ref="note"  rows="5" class="form-control" v-model="rejectnote" v-if="beReject" :readonly="beReject" style="height:200px"></textarea>
            <label
              v-if="isValid === false"
              id="basic-error"
              class="validation-invalid-label"
              for="basic"
            >{{ $t('ui.SYS00018') }}</label>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="submitNoteClick">{{$helper.getWord('OK')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config.js";
import helper from "@/vueHelper";
import api from "@/api";
import { mapGetters } from 'vuex';
export default {
  name: "PageHeader",
  props: [
    "wfDtl",
    "page",
    "reqdtl",
    "formData",
    "type",
    "gridData",
    "isShow",
    "deleteList",
    "isEdit",
    "beReject",
    "hasNote",
    "rejectnote",
    "refno"
  ],
  data() {
    return {
      isValid: true,
      isMounted: false,
      note: null,
      ticon: false
    };
  },
  computed: {
    breadcrumbs() {
      return this.$route.meta.breadcrumbs ? this.$route.meta.breadcrumbs : [];
    },
    title() {
      return this.$route.meta.title;
    },
  },
  mounted() {
    if ($("body").hasClass("sidebar-mini")) {
      $(".pageHeader").css("left", "65px");
    } else if ($("body").hasClass("sidebar-gone")) {
      $(".pageHeader").css("left", "0px");
    } else {
      $(".pageHeader").css("left", "250px");
    }
    if ($("body").hasClass("sidebar-gone")) {
          return;
    }
     $("[data-toggle='sidebar']").click(() => {
      this.$nextTick(() => {
        if ($(window).outerWidth() <= 1024) {
          return;
        }
        if ($("body").hasClass("sidebar-mini")) {
          $(".pageHeader").animate({ left: "65px" }, 250);
        } else {
          $(".pageHeader").animate({ left: "250px" }, 250);
        }
      });
    });

   

  },
  watch: {
    // $route() {
    //   this.breadcrumbs = this.$route.meta.breadcrumbs;
    // }
  },
  updated() {
    let $vm = this;
    if (window.innerWidth <= 768) {
      $("#card-action").css("padding-bottom", "10px");
    } else {
      $("#card-action").css("padding-bottom", "0px");
    }

    $(".deleteButton").click(function() {
      $vm.gridData.netAmount = 0;
      $.each($(".netGroup"), function(index, val) {
        if (val.value != "" && val.value != null) {
          $vm.gridData.netAmount += parseInt(val.value);
        }
      });
      $vm.gridData.gstAmount = 0;
      $.each($(".gstGroup"), function(index, val) {
        if (val.value != "" && val.value != null) {
          $vm.gridData.gstAmount += parseInt(val.value);
        }
      });
      $vm.gridData.grossAmount = 0;
      $.each($(".grossGroup"), function(index, val) {
        if (val.value != "" && val.value != null) {
          $vm.gridData.grossAmount += parseInt(val.value);
        }
      });
    });

    $(".netGroup").change(function() {
      $vm.gridData.netAmount = 0;
      $.each($(".netGroup"), function(index, val) {
        if (val.value != "" && val.value != null) {
          $vm.gridData.netAmount += parseInt(val.value);
        }
      });
    });
    $(".gstGroup").change(function() {
      $vm.gridData.gstAmount = 0;
      $.each($(".gstGroup"), function(index, val) {
        if (val.value != "" && val.value != null) {
          $vm.gridData.gstAmount += parseInt(val.value);
        }
      });
    });
    $(".grossGroup").change(function() {
      $vm.gridData.grossAmount = 0;
      $.each($(".grossGroup"), function(index, val) {
        if (val.value != "" && val.value != null) {
          $vm.gridData.grossAmount += parseInt(val.value);
        }
      });
    });
  },
  methods: {
    formatPath(p) {
      return (config.serverBase + p).replace("//", "/");
    },
    wfActionClicked(action, requiredNote) {
      if (requiredNote && !this.note) {
        this.isValid = false;
        $(this.$refs.note).focus();
        return false;
      } else {
        this.$emit("wfAction", action);
      }
    },
    isActionValid(cond) {
      if (!cond) return true;

      /* eslint no-new-func: 0 */
      var f = new Function("page", "return " + cond);

      return f(this.page);
    },
    formatFromNow(d) {
      return moment.utc(d).fromNow();
    },
    formatDateTime(d) {
      return moment.utc(d).format(config.momentDateTimeFormat);
    },
    formatDate(d) {
      return moment.utc(d).format(config.momentDateFormat);
    },
    noteChanged() {
      this.$emit("wfNoteChanged", this.note);
    },
    submitNoteClick() {
      if(!this.beReject){
      this.$emit("wfNoteChanged", this.note);
      // if (this.pendingAction) {
        // if (this.pendingAction.required_note && !this.note) {
        //   return false;
        // }
        for(var i=0;i<this.wfDtl.wfActions.length;i++){
          if(this.wfDtl.wfActions[i].name=="Reject"){
              this.$emit("wfAction", this.wfDtl.wfActions[i]);
          }
        }
       
        // this.pendingAction = null;
      }
   
      // }
      $("#wfNoteDialog")
        .modal("hide")
        .data("bs.modal", null);
    

    },
    cancelNoteClick() {
      this.note = this.orgNote;
      $("#wfNoteDialog")
        .modal("hide")
        .data("bs.modal", null);
    },
    wfNoteClicked() {
      this.isValid = true;
      if ($("#wfNoteDialog").parent("body").length === 0) {
        $("#wfNoteDialog").appendTo("body");
      }
      if ($("#wfNoteDialog").data("bs.modal") === null) {
        $("#wfNoteDialog").modal();
      }
      this.orgNote = this.note;

      $("#wfNoteDialog").modal("show");
    },
    previousAction(workflows, index) {
      if (workflows.length - 1 == index) {
        return moment
          .utc(workflows[index].action_on)
          .format(config.momentDateTimeFormat);
      } else {
        return moment
          .utc(workflows[index + 1].action_on)
          .format(config.momentDateTimeFormat);
      }
    },

  }
};
</script>

